import React, { useEffect, useRef } from 'react';

const services = [
  "Реєстрація бізнесу під ключ",
  "Ведення бухгалтерського обліку та кадрів, оптимізація податкового навантаження",
  "Професійна консультація з приводу ведення ФОП та ЄП",
  "Підвищення кваліфікації вашого бухгалтера",
  "Онлайн підтримка 24/7",
];

function BusinessRegistration() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll('.reg-item');
            items.forEach((item, i) => {
              setTimeout(() => {
                item.style.opacity = '1';
                item.style.transform = 'translateX(0)';
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} style={{
      padding: '100px 24px',
      background: '#0a0a0f',
    }}>
      <div style={{ maxWidth: 700, margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(22px, 3.5vw, 36px)',
          fontWeight: 700,
          color: '#fff',
          marginBottom: 50,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}>
          Наші <span style={{
            background: 'linear-gradient(135deg, #16b724, #4dc247)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>послуги</span>
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {services.map((text, i) => (
            <div key={i} className="reg-item" style={{
              opacity: 0,
              transform: 'translateX(-30px)',
              transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
              display: 'flex',
              alignItems: 'center',
              gap: 16,
              padding: '20px 24px',
              borderRadius: 14,
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.06)',
            }}>
              <div style={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #16b724, #0e8a1a)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                fontSize: 14,
                fontWeight: 700,
                color: '#fff',
              }}>
                ✓
              </div>
              <span style={{
                color: 'rgba(255,255,255,0.8)',
                fontSize: 15,
                lineHeight: 1.5,
              }}>
                {text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BusinessRegistration;
